import axios from 'axios';

const rawBaseUrl = process.env.REACT_APP_BASE_URL || 'http://localhost:8000/';
export const BASE_URL = rawBaseUrl.replace(/\/?$/, '/');

// Centralized Axios instance — all API calls go through here
const api = axios.create({
  baseURL: BASE_URL + 'api/v1/',
  timeout: 30000,
  headers: { Accept: 'application/json' },
});

// In-memory token store (set via setDefaultHeader)
let authToken = null;

// Request interceptor: attach auth token to every request automatically
api.interceptors.request.use((config) => {
  const token = authToken || sessionStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export function setDefaultHeader(value) {
  authToken = value;
}

export function postCheckToken(data) {
  return api.post('checkToken', data);
}
export function postLogin(data) {
  return api.post('login', data);
}
export function postSignup(data) {
  return api.post('signup', data);
}
export function getAllRestaurants() {
  return api.get('getAllRestaurants');
}
export function getRestaurantById(data) {
  return api.get('getRestaurantById', { params: data });
}
export function postUpSertRestaurant(data) {
  return api.post('upSertRestaurant', data);
}
export function postUpSertCategory(data) {
  return api.post('upSertCategory', data);
}
export function postUpSertItem(data) {
  return api.post('upSertItem', data);
}
export function getAllCurrencies() {
  return api.get('getAllCurrencies');
}
export function getAllDietaryOptions() {
  return api.get('getAllDietaryOptions');
}
export function postLogout() {
  return api.post('logout');
}
export function postUploadMenuPdf(data) {
  return api.post('uploadMenuPdf', data);
}
